import { ObjectMapper } from "json-object-mapper";
import { IModel } from "../IModel";
import { Model } from "../model";

export class ProbationaryPeriodEmployeeModel
  extends Model
  implements IModel<ProbationaryPeriodEmployeeModel>
{
  public name: string = "";
  public period: number = 0;
  public progressDays: number = 0;
  public registration: string = "";
  public jobTitle: string = "";
  public jobTitleGroupId: string = "";
  public jobTitleGroupName: string = "";
  public costCenterName: string = "";
  public employeeId: string = "";
  public assessmentModel: number = 0;
  public targetDays: number = 0;
  public rangePeriod: string = "";
  public companyGroupId: string = "";
  public companyName: string = "";
  public endFirstTrialPeriod: string = "";
  public endLastTrialPeriod: string = "";
  public firstAssessmentStatus: string = "";
  public firstAssessmentFormManagerId: string = "";
  public firstAssessmentFormEmployeeId: string = "";
  public firstAssessmentDate: string = "";
  public secondAssessmentFormManagerId: string = "";
  public secondAssessmentFormEmployeeId: string = "";
  public secondAssessmentDate: string = "";
  public secondAssessmentStatus: string = "";
  public finalDecision: string = "";
  public evaluationStatus: string = "";
  public firstPeriodExpired: boolean = true;
  public secondPeriodExpired: boolean = true;
  public dateRangeAnswerForm: string = "";
  public firstAssessmentDecisionTypeId: string = null;
  public secondAssessmentDecisionTypeId: string = null;
  public finalize: boolean = false;
  public discharge: boolean = false;

  static create(input: any): ProbationaryPeriodEmployeeModel {
    return ObjectMapper.deserialize<ProbationaryPeriodEmployeeModel>(
      ProbationaryPeriodEmployeeModel,
      input
    );
  }

  public toJSON(): string {
    return ObjectMapper.serialize(this) as string;
  }
}
